import { LoadingOutlined, UserOutlined } from '@ant-design/icons';
import { Spin, Input } from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';

import * as S from './styled';
import { useRecoveryPage } from './useRecoveryPage';

import { Shell } from '../../../atoms/Shell/Shell';
import { CelescLogos } from '../CelescLogos';

const antLoadingIcon = <LoadingOutlined style={{ fontSize: 40, margin: 10 }} spin />;

const RecoverPage = () => {
  const {
    handleFormSubmit,
    isLoginLoading,
    isSubmitting,
    isVerified,
    recaptchaExpired,
    recaptchaLoaded,
    theme
  } = useRecoveryPage();

  return (
    <S.RecoverFormPageWrapper>
      {theme ? (
        <img
          src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo.png`}
          className={`${theme}-logo-auth`}
        />
      ) : <Shell height={50} width={200} />}

      <S.RecoverFormWrapper>
        <S.RecoverFormTitleWrapper>
          <S.RecoverFormTitle>{T('Password recovery')}</S.RecoverFormTitle>

          <p className="information">{T('Enter your email to receive the verification code.')}</p>
        </S.RecoverFormTitleWrapper>

        <form onSubmit={handleFormSubmit}>
          <S.RecoverFormInputWrapper>
            <Input
              className="input"
              id="email"
              type="email"
              size="large"
              placeholder="Usuário"
              autoComplete="new-password"
              prefix={<UserOutlined style={{ color: '#c1c6cb'}} />}
            />
          </S.RecoverFormInputWrapper>

          <S.ReCaptchaWrapper>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              render="explicit"
              onChange={recaptchaLoaded}
              onExpired={recaptchaExpired}
            />
          </S.ReCaptchaWrapper>

          {isLoginLoading ? (
            <Spin
              style={{ display: 'flex', justifyContent: 'center' }}
              indicator={antLoadingIcon}
            />
          ) : (
            <S.RecoverFormButtonWrapper>
              <S.RecoverFormButton
                type="submit"
                disabled={isSubmitting || !isVerified}
              >
                {T('Submit')}
              </S.RecoverFormButton>
            </S.RecoverFormButtonWrapper>)}
          <S.RegisterText>
            <Link to="/auth/login"> {T('Back to')} login.</Link>
          </S.RegisterText>
        </form>
      </S.RecoverFormWrapper>

      {theme === 'celesc' && <CelescLogos />}
    </S.RecoverFormPageWrapper>
  );
};

export default RecoverPage;
